module.exports = "/images/CostaRica.png?fee1fd653a210580877cee98713d2c6a";